<template>
  <v-app>
    <v-snackbar v-model="snackbar" ref="snackBar">
      {{ msg }}
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-content class="fluid fill-height">
      <v-stepper v-model="e1" class="elevation-0 fill-height">
        <v-stepper-header class="elevation-0">
          <v-stepper-step :editable="true" :complete="e1 > 1" step="1">Dados do Psicólogo</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step :editable="true" step="2">Áreas de Atuação</v-stepper-step>
        </v-stepper-header>

        <v-stepper-items>
          <v-stepper-content step="1">
            <v-row class="align-center justify-center">
              <v-col class="col-4 ma-0 pa-0">
                <ButtonFoto
                  title="Foto de Perfil"
                  v-bind:email="email"
                  v-on:url-img="saveImgProfile"
                  folder="psicologo"
                  name_img="profileImg"
                />
                <v-select
                  :items="list_language"
                  v-model="language"
                  label="Idioma"
                  @change="getLanguage"
                  solo
                  flat
                  background-color="#F7F7F7"
                ></v-select>
              </v-col>
            </v-row>
            <v-row class="align-center justify-center">
              <v-col class="col-12 col-md-12">
                <v-form v-model="valid2" ref="form">
                  <v-container>
                    <v-row class="justify-center">
                      <v-col class="col-12 col-sm-6 col-md-4">
                        <v-text-field
                          solo
                          flat
                          label="Nome Completo"
                          v-model="name"
                          :rules="rules"
                          required
                          background-color="#F7F7F7"
                        ></v-text-field>
                        <v-select
                          :items="list_gender"
                          v-model="gender"
                          label="Sexo"
                          @change="getGender"
                          :rules="rules"
                          required
                          solo
                          flat
                          background-color="#F7F7F7"
                        ></v-select>

                        <v-text-field
                          filled
                          flat
                          label="Habilitações Académicas"
                          placeholder="Sou douturanda e tenho dois mestrados na área de ansiedade infantil."
                          v-model="academic_degree"
                          :rules="rules"
                          required
                          background-color="#F7F7F7"
                        ></v-text-field>
                        <v-row>
                          <v-col class="col-4 py-0">
                            <v-select
                              label="R$"
                              :items="list_symbol"
                              @change="getSymbol"
                              v-model="symbol"
                              :rules="rules"
                              required
                              solo
                              flat
                              background-color="#F7F7F7"
                            ></v-select>
                          </v-col>
                          <v-col class="col-8 py-0">
                            <money v-model="price" v-bind="money"></money>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col class="col-12 col-sm-6 col-md-4">
                        <v-text-field
                          solo
                          flat
                          label="Nacionalidade"
                          v-model="nation"
                          :rules="rules"
                          required
                          background-color="#F7F7F7"
                        ></v-text-field>
                        <v-autocomplete
                          solo
                          flat
                          hide-no-data
                          clearable
                          label="Fuso horário"
                          :items="time_zone"
                          v-model="time_zone_name"
                          :rules="rules"
                          required
                          background-color="#F7F7F7"
                        ></v-autocomplete>
                        <v-text-field
                          solo
                          flat
                          label="Cidade"
                          v-model="city"
                          :rules="rules"
                          required
                          background-color="#F7F7F7"
                        ></v-text-field>
                        <v-text-field
                          solo
                          flat
                          :label="$t('pageCadastro.labelDestrito')"
                          v-model="state"
                          :rules="rules"
                          required
                          background-color="#F7F7F7"
                        ></v-text-field>
                        <v-textarea
                          solo
                          flat
                          label="Biografia"
                          v-model="biography"
                          background-color="#F7F7F7"
                        ></v-textarea>
                      </v-col>
                    </v-row>
                    <v-row class="flex-column align-center justify-center">
                      <v-btn
                        class="my-5"
                        color="secondary"
                        depressed
                        large
                        @click="e1 = 2"
                        :disabled="!valid2"
                      >CONTINUAR</v-btn>
                      <v-btn text to="profile">Cancelar</v-btn>
                    </v-row>
                  </v-container>
                </v-form>
              </v-col>
            </v-row>
          </v-stepper-content>

          <v-stepper-content step="2">
            <v-row class="align-center justify-center">
              <v-col class="col-12">
                <v-form>
                  <v-container>
                    <v-row class="justify-center">
                      <v-col class="col-12 col-sm-8">
                        <h2 class="primary--text">Áreas de Atuação</h2>
                        <p class="font-italic">Selecione uma ou mais áreas.</p>
                        <v-row row wrap>
                          <v-col
                            class="shrink pa-1 col-auto"
                            v-for="(especiality,index) in types"
                            :key="index"
                          >
                            <v-checkbox
                              class="specialities"
                              v-model="selected"
                              :value="especiality.id"
                              :label="especiality.description"
                            ></v-checkbox>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-form>
              </v-col>
            </v-row>
            <v-row class="flex-column align-center justify-center">
              <v-btn
                class="mb-2"
                color="secondary"
                depressed
                large
                @click="submit"
                :loading="loader"
              >{{$t('pageEditProfile.btnSalvar')}}</v-btn>
              <v-btn text to="profile">Cancelar</v-btn>
            </v-row>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-content>
  </v-app>
</template>

<script>
import http from '@/services/httpClient';
import ButtonFoto from '@/components/ButtonFoto';
import moment from 'moment-timezone';
import { Money } from 'v-money';

export default {
  components: {
    ButtonFoto,
    Money,
  },
  data() {
    return {
      valid: false,
      valid2: false,
      loader: false,
      show1: false,
      show2: false,
      e1: 1,
      photo_profile: '',
      name: '',
      list_gender: ['Masculino', 'Feminino', 'Não Definido'],
      gender: '',
      list_symbol: ['R$', '€'],
      symbol: '',
      list_language: ['pt-BR', 'pt'],
      language: '',
      date: '',
      date_birth: null,
      academic_degree: '',
      biography: '',
      nation: '',
      city: '',
      state: '',
      opp: '',
      photo_opp_front: '',
      photo_opp_back: '',
      price: '',
      money: {
        precision: 2,
        masked: false,
      },
      time_zone: moment.tz.names(),
      time_offset: '',
      time_zone_name: '',
      email: '',
      check_email: '',
      password: '',
      check_password: '',
      checkbox: false,
      rules: [v => !!v || 'Esse campo é obrigatório'],
      snackbar: false,
      msg: '',
      menu: false,
      types: [],
      selected: [],
      cod: '',
      page: 1,
    };
  },

  async created() {
    this.getCod();
    await this.getProfile();
    this.getSpecialities();
  },
  watch: {
    time_zone_name(val) {
      if (val) {
        const m = moment().tz(val);
        this.time_offset = m.format('Z');
        this.time_zone_name = val;
      }
    },
  },
  methods: {
    getGender(v) {
      this.gender = v;
    },
    getLanguage(v) {
      this.language = v;
    },
    getSymbol(v) {
      this.symbol = v;
    },

    async submit() {
      if (this.$refs.form.validate()) {
        this.loader = true;
        await this.editProfile();
      }
    },

    editProfile() {
      let appointment_br_value = '0';
      let appointment_pt_value = '0';
      if (this.symbol == 'R$') {
        appointment_br_value = this.price;
      } else if (this.symbol == '€') {
        appointment_pt_value = this.price;
      }
      http
        .patch(
          `/psychologists/${this.cod}/`,
          {
            name: this.name,
            gender: this.gender,
            language: this.language,
            academic_degree: this.academic_degree,
            biography: this.biography,
            country: this.nation,
            city: this.city,
            state: this.state,
            photo: this.photo_profile,
            time_zone: this.time_offset,
            time_zone_name: this.time_zone_name,
            appointment_br_value,
            appointment_pt_value,
          },
          {
            headers: {
              Authorization: `Token ${localStorage.getItem('user-token')}`,
            },
          },
        )
        .then((response) => {
          http
            .post(
              `/psychologists/${response.data.id}/specialities/`,
              {
                id: this.selected,
              },
              {
                headers: {
                  Authorization: `Token ${localStorage.getItem('user-token')}`,
                },
              },
            )
            .then((res) => {
              this.msg = 'Atualização realizado com sucesso!';
              this.snackbar = true;
              setTimeout(() => {
                this.$router.replace('/psicologo/profile');
              }, 3000);
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch((e) => {
          console.log(e.response.data);
          if (e.response.data.email) {
            this.snackbar = true;
            this.msg = e.response.data.email;
          }
          if (
            e.response.data.appointment_br_value
            || e.response.data.appointment_pt_value
          ) {
            this.snackbar = true;
            this.msg = e.response.data.appointment_br_value
              ? e.response.data.appointment_br_value[0]
              : e.response.data.appointment_pt_value[0];
          }
        })
        .finally(() => (this.loader = false));
    },

    getSpecialities() {
      http
        .get('/specialities/', {
          params: {
            page: this.page,
          },
        })
        .then((res) => {
          const { results, next } = res.data;
          for (const item of results) {
            this.types.push(item);
          }
          if (next != null) {
            this.page = this.page + 1;
            this.getSpecialities();
          }
        });
    },

    getProfile() {
      http
        .get(`/psychologists/${this.cod}/`, {
          headers: {
            Authorization: `Token ${localStorage.getItem('user-token')}`,
          },
        })
        .then((response) => {
          const user = response.data;
          // console.log(response.data);

          this.name = user.name;
          this.gender = user.gender;
          this.language = user.language;
          this.academic_degree = user.academic_degree;
          this.biography = user.biography;
          this.nation = user.country;
          this.city = user.city;
          this.state = user.state;
          this.photo_profile = user.photo;
          this.time_zone_name = user.time_zone_name;
          this.price = user.appointment_br_value == 0
            ? user.appointment_pt_value
            : user.appointment_br_value;
          this.symbol = user.appointment_br_value == 0 ? '€' : 'R$';

          http
            .get(`/psychologists/${this.cod}/specialities`, {
              headers: {
                Authorization: `Token ${localStorage.getItem('user-token')}`,
              },
            })
            .then((response) => {
              for (const item of response.data) {
                this.selected.push(item.id);
              }
            });
        });
    },

    getCod() {
      this.cod = localStorage.getItem('user-id');
    },

    saveImgProfile(value) {
      this.photo_profile = value;
    },
  },
};
</script>

<style scoped>
* >>> .specialities {
  margin-top: 0px;
}

* >>> .specialities .v-input--selection-controls__input {
  display: none;
}

*
  >>> .specialities.v-input--selection-controls:not(.v-input--hide-details)
  .v-input__slot {
  margin-bottom: 0;
  background: #ffffff;
  border: 2px solid #02a554;
  padding: 8px 16px;
  border-radius: 23px;
}
* >>> .specialities.v-input--selection-controls.v-input .v-label {
  color: #02a554;
}
* >>> .specialities.v-input--is-label-active .v-input__control .v-input__slot {
  background: #02a554;
}

*
  >>> .specialities.v-input--is-label-active.v-input--selection-controls.v-input
  .v-label {
  color: #ffffff;
}

* >>> .v-input__slot:after {
  display: none;
}

* >>> .v-input__slot:before {
  display: none;
}
.v-money {
  height: 48px;
  width: 100%;
  background-color: rgb(247, 247, 247);
  border-radius: 4px;
  padding: 10px;
  caret-color: #93291e;
}
.v-money:focus {
  outline-offset: unset;
  outline: none;
}
</style>
